<template>
    <v-btn small color="secondary" :outline="outline" @click="$emit('click')" class="no-mobile">
        {{label}}
    </v-btn>
</template>

<script>
    export default {
        name: 'MinhasLicitacoesTabelaAcaoPrincipal',
        props: {
            favoritos: {
                type: Boolean,
                default: false
            },
            licitacao: {
                type: Object,
                required: true
            }
        },
        computed: {
            label() {
                if (this.favoritos) {
                    return 'Lançar Proposta'
                } else if (this.podeAcessarPregao(this.licitacao) && this.licitacao.modalidade !== 'CREDENCIAMENTO') {
                    return 'Participar'
                } else if (this.licitacao.enviada && !this.podeAcessarPregao(this.licitacao)) {
                    return 'Ver Minha Proposta'
                } else if (this.licitacao.modalidade === 'CREDENCIAMENTO') {
                    return 'Acessar'
                } else {
                    return 'Continuar Proposta'
                }
            },
            outline() {
                return !this.favoritos && !this.licitacao.podeAcessar
            }
        }
    }
</script>